export default "__VITE_ASSET__DTR5$M11__"